export const colors = [
  //
  '#ce88ce',
  '#6d69bd',
  '#5cb2c7',
  '#405960',
  '#5e9f81',
  '#7a7287',
  '#ceabb2',
  '#6ba34c',
  '#dd8e41',
  '#b5bcb4'
];
